import { Card, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import moment from "moment";
import {
  useDeleteNotification,
  useGetNotificationPending,
  useGetNotificationSent,
} from "../notification.hook";
import MDButton from "components/MDButton";
import { Notification } from "../notification.type";

interface TableNotificationProps {
  type: "pending" | "sent";
}

function TableNotification({ type }: TableNotificationProps): JSX.Element {
  const deleteNotification = useDeleteNotification();
  const { data: dataPendingNotif } = useGetNotificationPending();
  const { data: dataSentNotif } = useGetNotificationSent();

  const tableConfig = {
    pending: {
      title: "Notifications en attente",
      subtitle: "Liste des notifications en attente",
      data: dataPendingNotif,
      columns: [
        {
          Header: "Titre",
          accessor: "title",
        },
        {
          Header: "Text",
          accessor: "body",
        },
        {
          Header: "prévu",
          accessor: "scheduled",
          Cell: ({ row }: any) =>
            moment(row.original.scheduled).format("DD-MM-YYYY HH:mm"),
        },
        {
          Header: "Action",
          accessor: "action",
          Cell: ({ row }: any) => {
            return (
              <MDBox display="flex" alignItems="center">
                <MDButton
                  variant="text"
                  color="error"
                  onClick={() => handleDelete(row.original)}
                >
                  <Icon>delete</Icon>
                </MDButton>
              </MDBox>
            );
          },
        },
      ],
    },
    sent: {
      title: "Notifications envoyées",
      subtitle: "Liste des notifications envoyées",
      data: dataSentNotif,
      columns: [
        { Header: "Titre", accessor: "title" },
        { Header: "Text", accessor: "body" },
        {
          Header: "envoyé",
          accessor: "scheduled",
          Cell: ({ row }: any) =>
            moment(row.original.scheduled).format("DD-MM-YYYY HH:mm"),
        },
        {
          Header: "Action",
          accessor: "action",
          Cell: ({ row }: any) => (
            <MDBox display="flex" alignItems="center">
              <MDButton
                variant="text"
                color="error"
                onClick={() => handleDelete(row.original)}
              >
                <Icon>delete</Icon>
              </MDButton>
            </MDBox>
          ),
        },
      ],
    },
  };

  const handleDelete = async (notification: Notification) => {
    const confirmed = window.confirm(
      "Êtes-vous sûr de vouloir supprimer cet élément ?"
    );
    if (confirmed) {
      await deleteNotification.mutateAsync(notification?.id);
    }
  };

  const { title, subtitle, data, columns } = tableConfig[type];

  const sortedData =
    type === "sent"
      ? [...(data || [])].sort(
          (a, b) =>
            moment(b.scheduled).valueOf() - moment(a.scheduled).valueOf()
        )
      : data;

  const tableData = { columns, rows: sortedData };

  return (
    <MDBox>
      <Card>
        <MDBox p={3} lineHeight={1}>
          <MDTypography variant="h5" fontWeight="medium">
            {title}
          </MDTypography>
          <MDTypography variant="button" color="text">
            {subtitle}
          </MDTypography>
        </MDBox>
        {data && <DataTable table={tableData} canSearch />}
      </Card>
    </MDBox>
  );
}

export default TableNotification;
